<template>
  <v-card>
    <v-form ref="form" lazy-validation>
      <v-card-text class="py-0">
        <v-container grid-list-md class="pa-0" style="min-width: 100%;">
          <v-layout v-if="permiso.id_tipo_permiso == 96">
            <v-flex md4>
              <v-radio-group
                v-model="radio_data"
                row
                :rules="[
                  v => {
                    if (v == null) return 'El campo es obligatorio.';
                    return true;
                  }
                ]"
              >
                <v-flex xs6>
                  <v-radio label="Con compensación" :value="1"></v-radio>
                </v-flex>
                <v-flex xs6>
                  <v-radio label="Sin compensación" :value="0"></v-radio>
                </v-flex>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <!-- Cargado de archivos-->
          <!-- para adjuntos no obligatorios-->
          <p>Respaldo</p>
          <v-layout v-if="permiso.id_tipo_permiso == 96">
            <v-flex xs12 md4>
              <input
                type="file"
                @change="handleFileUpload()"
                ref="file"
                accept="application/pdf"
                v
              />
              <p class="red--text body-1" v-if="errors.denied">
                *Formato no admitido por el sistema
              </p>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-btn
              color="primary"
              @click="save2()"
              v-if="
                permiso.id_tipo_permiso == 96 &&
                  radio_data == 0 &&
                  permiso.motivo &&
                  permiso.fecha_desde &&
                  permiso.hora_desde &&
                  permiso.hora_hasta
              "
            >
              <v-icon>save</v-icon>
              Guardar
            </v-btn>
            <v-btn
              v-if="radio_data == 0 && permiso.id_tipo_permiso == 96"
              color="error"
              :to="`/permisos/usuario/${getPersonaId()}`"
            >
              <v-icon>clear</v-icon>
              Cancelar
            </v-btn>
          </v-layout>
        </v-container>
      </v-card-text>
      <!-- Formulario compensaciones -->
      <v-card-text v-if="radio_data == 1">
        <v-layout>
          <v-flex md4>
            <p>
              <strong>Total horas a compensar:</strong>

              {{ this.diferencia_horas }}
            </p>
          </v-flex>
        </v-layout>
        <!-- Fecha compensacion -->
        <v-layout>
          <v-flex md4>
            <v-text-field
              type="date"
              v-model="form.fecha_desde"
              label="Fecha"
              :rules="$validate(['required'])"
              required
              @input="verificaCompensacion()"
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex md6>
            <v-radio-group
              v-model="form.tipo_dia"
              @change="verificaCompensacion()"
            >
              <!-- <v-flex>
                <v-radio label="Mañana" value="1"></v-radio>
              </v-flex> -->
              <v-flex>
                <v-radio label="Tarde" value="2"></v-radio>
              </v-flex>
            </v-radio-group>
          </v-flex>
          <v-flex md6>
            <v-radio-group
              v-model="form.horario"
              @change="verificaCompensacion()"
            >
              <!-- <v-radio label="Ingreso" value="1"></v-radio> -->
              <v-radio label="Salida" value="2"></v-radio>
            </v-radio-group>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md4>
            <v-select
              value="hora"
              :items="rango_horarios"
              type="hour"
              item-value="hora"
              item-text="hora"
              label="Cantidad de horas"
              v-model="form.horas_compensa"
              autofocus
              :rules="$validate(['required'])"
              required
              @input="verificaCompensacion()"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md4>
            <v-text-field
              type="time"
              label="Hora desde"
              v-model="hora_desde_calculada"
              disabled
            />
          </v-flex>
          <v-flex md4>
            <v-text-field
              type="time"
              label="Hora hasta"
              v-model="hora_hasta_calculada"
              disabled
            />
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex md6>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="cargarCompensacion()">
              <v-icon>arrow_downward</v-icon>
              Registrar
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card-text>

      <v-card-text v-if="radio_data == 1">
        <h3><strong>Detalles compensación</strong></h3>
        <v-layout>
          <v-flex xs12>
            <v-data-table
              class="elevation-1 tabla-comprimida-light"
              :items="compensaciones"
              hide-actions
              :headers="headers"
            >
              <template v-slot:items="props">
                <td class="text-xs-center">
                  {{ $moment(props.item.fecha).format("DD/MM/YYYY") }}
                </td>
                <td class="text-xs-center">{{ props.item.hora_desde }}</td>
                <td class="text-xs-center">{{ props.item.hora_hasta }}</td>
                <td class="text-xs-center">
                  {{ props.item.total_horas }}
                </td>
                <td class="text-xs-center">
                  <v-btn
                    color="error"
                    icon
                    title="Eliminar compensacion"
                    @click="borrarCompensacionDetalle(props.item.id)"
                  >
                    <v-icon>delete</v-icon>
                  </v-btn>
                </td>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
        <v-layout class="pa-2">
          <v-flex xs12>
            <h4>
              <strong
                >Total horas:
                {{ total_horas_compensacion.format("HH:mm") }}</strong
              >
            </h4>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions class="pr-4" v-if="radio_data == 1">
        <v-spacer></v-spacer>
        <v-btn
          @click.native="save()"
          color="primary"
          v-if="
            permiso.motivo &&
              permiso.fecha_desde &&
              permiso.hora_desde &&
              permiso.hora_hasta
          "
        >
          <v-icon>save</v-icon>GUARDAR
        </v-btn>
        <v-btn :to="`/permisos/usuario/${getPersonaId()}`" color="error">
          <v-icon>cancel</v-icon>CANCELAR
        </v-btn>
      </v-card-actions>
    </v-form>
  </v-card>
</template>

<script>
import validate from "@/common/mixins/validate";

export default {
  mixins: [validate],
  props: ["item", "compensacion", "id_persona", "rol"],
  async mounted() {
    await this.diferenciaHoras().then(response => {
      if (response) {
        this.diferencia_horas = response;
      }
    });
    this.$bus.$on("actualizarHoraTolerancia", async () => {
      await this.diferenciaHoras().then(response => {
        if (response) {
          this.diferencia_horas = response;
        }
      });
    });
    if (this.file) {
      if (this.estado_archivo == 0) {
        this.errors.denied = false;
      } else {
        this.errors.denied = true;
      }
    } else {
      this.errors.denied = false;
      this.estado_archivo = null;
    }
  },
  data() {
    return {
      radio_data: this.compensacion,
      permiso: this.item,

      estado_archivo: null,
      errors: {
        denied: false
      },
      bandera_media_hora: true,

      file: null,
      form: {},
      compensaciones: [],
      rango_horarios: [
        {
          hora: "00:30"
        },
        {
          hora: "01:00"
        },
        {
          hora: "01:30"
        },
        {
          hora: "02:00"
        },
        {
          hora: "02:30"
        },
        {
          hora: "03:00"
        },
        {
          hora: "03:30"
        },
        {
          hora: "04:00"
        },
        {
          hora: "04:30"
        },
        {
          hora: "05:00"
        },
        {
          hora: "05:30"
        }
      ],

      headers: [
        {
          text: "Fecha",
          align: "center",
          sortable: false
        },
        {
          text: "Hora desde",
          align: "center",
          sortable: false
        },
        {
          text: "Hora hasta",
          align: "center",
          sortable: false
        },
        {
          text: "Total Horas",
          align: "center",
          sortable: false
        },
        {
          text: "Acción",
          align: "center",
          sortable: false
        }
      ],
      permiso_detalles: [],
      permisoDetalle: [],
      horas_disponibles: null,
      hora_desde_calculada: "",
      hora_hasta_calculada: "",
      total_horas_calculada: "",
      mensaje_error: "",
      bandera_compensacion: false,
      correlativo_compensacion: 0,
      total_horas_compensacion: this.$moment().set({
        hour: 0,
        minutes: 0,
        seconds: 0
      }),
      horas_compensacion: 0,
      diferencia_horas: null
    };
  },
  computed: {
    calculo_horas: async function() {
      console.log("hello");
      return await this.diferenciaHoras().then(response => {
        if (response) {
          this.diferencia_horas = response;
          return response;
        }
      });
    }
  },
  watch: {
    // permiso: async function(val) {
    //   console.log("hello");
    //   let rpta = await this.diferenciaHoras();
    //   if (rpta) {
    //     this.diferencia_horas = this.$moment(rpta,'HH:ss:ms').format('HH:ss');
    //   }
    //   console.log("----> ", this.diferencia_horas);
    // }
    permiso: async function(val) {
      await this.diferenciaHoras().then(response => {
        if (response) {
          this.diferencia_horas = response;
        }
      });
    }
  },
  methods: {
    // Metodo para obtener la diferencia de horas por funcionario segun horario
    async diferenciaHoras() {
      if (this.permiso.hora_desde) {
        let minutos1 = this.permiso.hora_desde.toString().split(":");
        if (minutos1 == "03") {
          this.compensacion = false;
          return;
        }
      }
      if (this.permiso.hora_hasta) {
        let minutos1 = this.permiso.hora_hasta.toString().split(":");
        if (minutos1 == "03") {
          this.compensacion = false;
          return;
        }
      }
      try {
        if (
          this.permiso.hora_desde &&
          this.permiso.hora_hasta &&
          this.permiso.fecha_desde
        ) {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_calcula_diferencia_horas_funcionario(${this.getPersonaId()},'${
              this.permiso.hora_desde
            }','${this.permiso.hora_hasta}','${this.permiso.fecha_desde}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0]
              .fn_calcula_diferencia_horas_funcionario;
          if (respuesta.split("|")[0] != "0") {
            return respuesta;
          }
          return null;
        }
      } catch (error) {
        console.log(error);
      }
    },

    async verificarRangoMediaHora() {
      try {
        if (this.permiso.hora_desde && this.permiso.hora_hasta) {
          let respuesta = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_valida_rangos_media_hora('${this.permiso.hora_desde}','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
          });
          respuesta =
            respuesta.runQuery.respuesta[0].fn_valida_rangos_media_hora;
          respuesta = respuesta.split("|");
          if (respuesta[0] == "1") {
            this.bandera_media_hora = true;

            return true;
          } else {
            this.bandera_media_hora = false;

            return false;
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    async verificaCompensacion() {
      try {
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculad = "";
        if (
          this.form.fecha_desde &&
          this.form.tipo_dia &&
          this.form.horario &&
          this.form.horas_compensa &&
          this.permiso.fecha_desde &&
          this.permiso.hora_desde &&
          this.permiso.hora_hasta
        ) {
          let id_persona = this.getPersonaId();
          ///permiso 88 goce de haberes
          if (this.permiso.id_tipo_permiso == 88) {
            let respuesta = await this.$service.graphql({
              query: `
                  query{
                    runQuery(consulta:"select control.fn_obtine_rangos_compensacion(${id_persona},'${
                this.form.fecha_desde
              }',${parseInt(this.form.tipo_dia)},${parseInt(
                this.form.horario
              )},'${this.form.horas_compensa}','${this.permiso.fecha_desde}','${
                this.permiso.hora_desde
              }','${this.permiso.hora_hasta}')"){
                      respuesta
                    }
                  }
                `
            });
            respuesta =
              respuesta.runQuery.respuesta[0].fn_obtine_rangos_compensacion;
            let horarios = respuesta.split("|");
            if (horarios[0] != "0") {
              this.hora_desde_calculada = horarios[1];
              this.hora_hasta_calculada = horarios[2];
              this.total_horas_calculada = horarios[3];
            } else {
              this.mensaje_error = horarios[1];
              this.$message.info(this.mensaje_error);
            }
          }
          ///permiso 96 tolerancia
          if (this.permiso.id_tipo_permiso == 96) {
            let respuesta = await this.$service.graphql({
              query: `
                  query{
                    runQuery(consulta:"select control.fn_obtine_rangos_compensacion_tolerancia(${id_persona},'${
                this.form.fecha_desde
              }',${parseInt(this.form.tipo_dia)},${parseInt(
                this.form.horario
              )},'${this.form.horas_compensa}','${this.permiso.fecha_desde}','${
                this.permiso.hora_desde
              }','${this.permiso.hora_hasta}')"){
                      respuesta
                    }
                  }
                `
            });
            respuesta =
              respuesta.runQuery.respuesta[0]
                .fn_obtine_rangos_compensacion_tolerancia;
            let horarios = respuesta.split("|");
            if (horarios[0] != "0") {
              this.hora_desde_calculada = horarios[1];
              this.hora_hasta_calculada = horarios[2];
              this.total_horas_calculada = horarios[3];
            } else {
              this.mensaje_error = horarios[1];
              this.$message.info(this.mensaje_error);
            }
          }
        }
      } catch (error) {
        console.log(error);
      }
    },
    cargarCompensacion() {
      if (
        this.form.fecha_desde &&
        this.form.tipo_dia &&
        this.form.horario &&
        this.form.horas_compensa &&
        this.hora_desde_calculada &&
        this.hora_hasta_calculada &&
        this.total_horas_calculada
      ) {
        let compensacion_crear = {
          id: this.correlativo_compensacion,
          fecha: this.form.fecha_desde,
          hora_desde: this.hora_desde_calculada,
          hora_hasta: this.hora_hasta_calculada,
          total_horas: this.total_horas_calculada
        };
        this.compensaciones.push(compensacion_crear);
        this.correlativo_compensacion += 1;
        this.form.fecha_desde = "";
        this.form.tipo_dia = "";
        this.form.horario = "";
        this.form.horas_compensa = "";
        this.hora_desde_calculada = "";
        this.hora_hasta_calculada = "";
        this.total_horas_calculada = "";
        this.$message.success("Registro exitoso");
        this.total_horas_compensacion.add(compensacion_crear.total_horas);
      } else {
        if (this.mensaje_error) {
          this.$message.warning(this.mensaje_error);
        } else {
          this.$message.warning("Revise si lleno todos los campos requeridos");
        }
      }
    },
    visualizaCompensacion() {
      this.bandera_compensacion = true;
    },
    async verificarCompensacion2() {
      if (
        parseInt(this.permiso.id_tipo_permiso) == 96 &&
        this.permiso.fecha_desde &&
        this.permiso.hora_desde &&
        this.permiso.hora_hasta &&
        this.radio_data == 1
      ) {
        //radio_data

        if (this.radio_data == 1) {
          let respuesta2 = await this.$service.graphql({
            query: `
              query{
                runQuery(consulta:"select control.fn_diferencia_horas('${this.permiso.hora_desde}','${this.permiso.hora_hasta}')"){
                  respuesta
                }
              }
            `
          });
          respuesta2 = respuesta2.runQuery.respuesta[0].fn_diferencia_horas;
          this.horas_compensacion = respuesta2;
          //this.debe_horas_compensacion = this.horas_compensacion;
          // console.log(this.debe_horas_compensacion , this.horas_compensacion)
        }
      }
      if (this.radio_data == 0) {
        this.horas_compensacion = 0;
      }
    },
    borrarCompensacionDetalle(id) {
      this.$confirm("¿Esta seguro de eliminar el registro?", () => {
        let posicion;
        let compensaciones_aux = [];
        for (let index = 0; index < this.compensaciones.length; index++) {
          const element = this.compensaciones[index];
          if (element.id != id) {
            compensaciones_aux.push(element);
          } else {
            this.total_horas_compensacion.subtract(element.total_horas);
          }
        }
        this.compensaciones = compensaciones_aux;
      });
    },
    getPersonaId() {
      const user = this.$storage.get("user");
      return this.$route.params.id ? this.$route.params.id : user.id_persona;
    },
    getRuta() {
      let p = this.$route.path;
      const a = p.split("/");
      return a[3];
    },
    async verificarPermisosRango(
      fecha_desde,
      fecha_hasta,
      hora_desde,
      hora_hasta
    ) {
      //Funcion notifica que hay un permiso creado en el rango de fechas seleccionado
      // control.fn_muestra_permisos_funcionario(p_id_persona integer, p_fecha date)
      let existePermisos = false;
      let permisos = "¿Esta seguro guardar el permiso?";
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select control.fn_permisos_por_funcionario(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}','${hora_desde}','${hora_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta = respuesta.runQuery.respuesta[0].fn_permisos_por_funcionario;
        respuesta = respuesta.split("|");
        if (respuesta[0] == "1") {
          existePermisos = true;
          permisos_consulta +=
            "<br><strong>Usted tiene los siguientes permisos en las fechas u horarios solicitados:</strong><br>" +
            respuesta[1].replace(/#/g, "<br>");
        }
      } catch (error) {
        console.log(error);
      }
      if (existePermisos) {
        this.$alert("No puede crear el permiso" + permisos_consulta);
      }
      return [existePermisos, permisos + permisos_consulta];
    },

    handleFileUpload() {
      if (this.$refs.file.value !== "") {
        const file = this.$refs.file.files[0];
        if (this.$refs.file.files[0].type.includes("application/pdf")) {
          this.errors.denied = false;
          this.estado_archivo = 0;
        } else {
          this.errors.denied = true;
          this.estado_archivo = 1;
        }
        this.file = file;
      }
    },

    //verifica que una vacacion aprobada no choque con el permiso:
    async verificaVacaciones(fecha_desde, fecha_hasta) {
      let existe_vacacion = false;
      let permisos_consulta = "";
      let respuesta;
      try {
        respuesta = await this.$service.graphql({
          query: `
              query{
                runQuery(consulta:"select vacaciones.fn_verifica_coincidencia_de_vacaciones_aprobadas(${this.getPersonaId()},'${fecha_desde}','${fecha_hasta}')"){
                  respuesta
                }
              }
            `
        });
        respuesta =
          respuesta.runQuery.respuesta[0]
            .fn_verifica_coincidencia_de_vacaciones_aprobadas;

        if (respuesta != "0") {
          existe_vacacion = true;
          permisos_consulta +=
            "<br><strong>Usted tiene la siguiente vacación aprobada en las fechas solicitadas:</strong><br>" +
            respuesta.replace(/#/g, "<br>");
          this.$message.warning(permisos_consulta);
        }
        return existe_vacacion;
      } catch (error) {
        console.log(error);
      }
    },
    async save2() {
      let rango_30_minutos = await this.verificarRangoMediaHora();
      if (rango_30_minutos == true) {
        if (this.$refs.form.validate()) {
          let ruta_archivo;
          let user = this.$storage.get("user");
          //consulta si existe una vacacion aprobada en ese rango de fechas
          let verifica_vacacion = await this.verificaVacaciones(
            this.permiso.fecha_desde,
            this.permiso.fecha_desde
          );
          if (verifica_vacacion == true) {
            return;
          }
          //consulta si existe un permiso aprobado en ese rango de fechas
          let consulta = await this.verificarPermisosRango(
            this.permiso.fecha_desde,
            this.permiso.fecha_desde,
            this.permiso.hora_desde,
            this.permiso.hora_hasta
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            let fecha_actual = this.$moment().format("YYYY-MM-DD");
            let respuesta;
            if (this.file) {
              if (this.errors.denied) {
                return this.errors;
              }
            }

            if (this.file != null) {
              let formData = new FormData();
              formData.append("file", this.file);
              let res = await this.$http.post(
                process.env.API_URL + "public/upload",
                formData
              );
              ruta_archivo = res.data;
            } else {
              ruta_archivo = "";
            }

            try {
              this.permiso.motivo = this.permiso.motivo.replace(
                /(\r\n|\n|\r)/gm,
                " "
              );
              this.permiso.motivo = this.permiso.motivo.replace(/"/g, "`");
              console.log("++++++", this.permiso.motivo);
              respuesta = await this.$service.graphql({
                query: `
              query{
                  runQuery(consulta:"select control.fn_registra_tolerancia(${parseInt(
                    this.id_persona
                  )},'${fecha_actual}',${user.id}, '${
                  this.permiso.fecha_desde
                }','${this.permiso.fecha_desde}','${
                  this.permiso.hora_desde
                }','${this.permiso.hora_hasta}','${this.permiso.motivo}',${
                  this.radio_data
                },'${ruta_archivo}',${parseInt(this.rol)})"){
                      respuesta
                        }
                    }
              `
              });

              console.log("select control.fn_registra_tolerancia",
      this.id_persona,
    fecha_actual,
                user.id, 
                  this.permiso.fecha_desde
                ,this.permiso.fecha_desde,
                  this.permiso.hora_desde,
                  this.permiso.hora_hasta,
                  this.permiso.motivo,
                  this.radio_data,
                  ruta_archivo,
                  this.rol
              );


            } catch (error) {
              console.log(error);
            }
            try {
              respuesta =
                respuesta.runQuery.respuesta[0].fn_registra_tolerancia;

              let resps = respuesta.split("|");
              let correcto = resps[0];

              if (correcto === "1") {
                this.$confirm("Registro exitoso", () => {});
                this.redireccionarUrl();
              } else {
                this.$confirm(resps[1], () => {});
              }
            } catch (error) {
              console.log(error);
            }
          });
        }
      } else {
        this.$confirm(
          "Los intervalos de horas deben de ser de 30 minutos",
          () => {}
        );
      }
    },
    redireccionarUrl() {
      if (this.getRuta() != this.getPersonaId()) {
        this.$router.push("/permisos/usuario/");
      }
      if (this.getRuta() == this.getPersonaId()) {
        this.$router.push("/permisos/usuario/" + this.getPersonaId());
      }
    },
    async save() {
      let rango_30_minutos = await this.verificarRangoMediaHora();

      if (this.radio_data == "1" && rango_30_minutos == true) {
        let mensaje_error_exito;
        //validar que seas pdf
        if (this.file) {
          if (this.errors.denied) {
            return this.errors;
          }
        }
        let horas_a_compensar = this.$moment(
          this.diferencia_horas,
          "HH:mm:ss"
        ).format("HH:mm");
        if (
          this.$moment(this.total_horas_compensacion, "HH:mm").format(
            "HH:mm"
          ) == this.$moment(horas_a_compensar, "HH:mm").format("HH:mm")
        ) {
          let ruta_archivo;
          let consulta = await this.verificarPermisosRango(
            this.permiso.fecha_desde,
            this.permiso.fecha_desde,
            this.permiso.hora_desde,
            this.permiso.hora_hasta
          );
          if (consulta[0] == true) {
            return;
          }
          this.$confirm(consulta[1], async () => {
            let id_permiso_creado;
            try {
              //guardar archivos:

              //obtener ruta
              if (this.file != null) {
                let formData = new FormData();
                formData.append("file", this.file);
                let res = await this.$http.post(
                  process.env.API_URL + "public/upload",
                  formData
                );
                ruta_archivo = res.data;
              } else {
                if (this.permiso.id_tipo_permiso == 96) {
                  ruta_archivo = "";
                  this.estado_archivo == 0;
                }
              }

              //Funcion para guardar el permiso
              let id_persona = this.permiso.id_persona;
              const user = this.$storage.get("user");
              let fecha_actual = this.$moment().format("YYYY-MM-DD");

              //permiso TOLERANCIA:
              if (this.permiso.id_tipo_permiso == 96) {
                this.permiso.motivo = this.permiso.motivo.replace(
                  /(\r\n|\n|\r)/gm,
                  " "
                );
                this.permiso.motivo = this.permiso.motivo.replace(/"/g, "`");
                let respuesta = await this.$service.graphql({
                  query: `
                  query{
                          runQuery(consulta:"select control.fn_registra_tolerancia(${parseInt(
                            this.id_persona
                          )},'${fecha_actual}',${user.id}, '${
                    this.permiso.fecha_desde
                  }','${this.permiso.fecha_desde}','${
                    this.permiso.hora_desde
                  }','${this.permiso.hora_hasta}','${
                    this.permiso.motivo
                  }',1,'${ruta_archivo}',${parseInt(this.rol)})"){
                              respuesta
                                }
                            }
                  `
                });
                let respuesta2 =
                  respuesta.runQuery.respuesta[0].fn_registra_tolerancia;
                let resps = respuesta2.split("|");
                let correcto = resps[0];
                if (correcto === "1") {
                  // this.$message.success("Registro exitoso del permiso");
                  mensaje_error_exito = "Registro exitoso";
                  id_permiso_creado = parseInt(resps[1]);

                  let esCorrecto = true;
                  for (
                    let index = 0;
                    index < this.compensaciones.length;
                    index++
                  ) {
                    const element = this.compensaciones[index];
                    let respuesta_comp = await this.$service.graphql({
                      query: `
                  query{
                      runQuery(consulta:"select control.fn_registra_compensacion_tolerancia(${id_permiso_creado},'${element.fecha}','${element.fecha}','${element.hora_desde}','${element.hora_hasta}',${user.id})"){
                          respuesta
                      }
                    }
                  `
                    });
                    let respuesta3 =
                      respuesta_comp.runQuery.respuesta[0]
                        .fn_registra_compensacion_tolerancia;
                    resps = respuesta3.split("|");
                    if (resps[0] == "0") {
                      this.$confirm(resps[1], () => {});
                      esCorrecto = false;
                      break;
                    }
                  }
                  if (esCorrecto) {
                    this.$confirm("Registro exitoso", () => {});
                    if (this.getRuta() != this.getPersonaId()) {
                      this.$router.push("/permisos/usuario/");
                    }
                    if (this.getRuta() == this.getPersonaId()) {
                      this.$router.push(
                        "/permisos/usuario/" + this.getPersonaId()
                      );
                    }
                  }
                } else {
                  this.$confirm(resps[1], () => {});
                }
              }
            } catch (error) {
              console.log(error);
            }
          });
        } else {
          this.$confirm(
            "Las horas de compensación no son iguales a las horas solicitadas",
            () => {}
          );
        }
      } else {
        this.$confirm(
          "Los intervalos de horas deben de ser de 30 minutos",
          () => {}
        );
      }
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/permiso/components/CompensacionTolerancia.vue